/**
 * Shared hidden <video> for the AINA intro. Primed from `useAuthStore.login`
 * when persisted session data is set so playback does not start during OTP/API
 * screens. (Browsers may still require a user gesture for audible autoplay;
 * the intro modal falls back to muted + tap-to-unmute when needed.)
 */

let primerHostEl: HTMLDivElement | null = null;
let primerVideoEl: HTMLVideoElement | null = null;

export function registerAinaIntroPrimer(
  host: HTMLDivElement | null,
  video: HTMLVideoElement | null,
) {
  primerHostEl = host;
  primerVideoEl = video;
}

export function getAinaIntroPrimerHost(): HTMLDivElement | null {
  return primerHostEl;
}

export function getAinaIntroPrimerVideo(): HTMLVideoElement | null {
  return primerVideoEl;
}

export function primeAinaIntroVideoFromUserGesture(): void {
  const el = primerVideoEl;
  if (!el) return;
  try {
    el.muted = true;
    void el.play().catch(() => {});
  } catch {
    /* ignore */
  }
}

/** Stop hidden primer playback (e.g. intro suppressed or profile switch without modal). */
export function pauseAndResetAinaIntroPrimerVideo(): void {
  const el = primerVideoEl;
  if (!el) return;
  try {
    el.pause();
    el.muted = true;
    el.currentTime = 0;
  } catch {
    /* ignore */
  }
}
